<ng-container [formGroup]="staffAddressForm">

  @if (addressDetail) {
    <app-address [isRequired]="true"
      [model]="addressDetail"
      formControlName="staff_address"
    [form]="form" ></app-address>
  }

</ng-container>
